(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jarvis-mission-bundles"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.jarvis-mission-bundles--add-all').forEach(root => {
      if (root.dataset.jarvisRoomResetAddAll === '20260920') return;
      root.dataset.jarvisRoomResetAddAll = '20260920';
      const routeRoot = `${root.dataset.rootUrl || '/'}`.replace(/\/?$/, '/');
      const message = key => root.dataset[`message${key}`];
      const request = async (path, options = {}) => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(`${routeRoot}${path}`, {
            credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal
          });
          if (!response.ok) throw new Error('request_failed');
          return await response.json();
        } finally {
          clearTimeout(timeout);
        }
      };
      const post = body => ({method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
      const attemptLines = (cart, attempt) => {
        if (!Array.isArray(cart.items)) throw new Error('invalid_cart');
        return cart.items.filter(item => item.properties?._cozy_room_reset === attempt);
      };
      const cleanupAttempt = async attempt => {
        const cart = await request('cart.js');
        const lines = attemptLines(cart, attempt);
        if (lines.length) {
          const updates = {};
          for (const line of lines) {
            if (typeof line.key !== 'string' || !line.key) throw new Error('invalid_line');
            updates[line.key] = 0;
          }
          await request('cart/update.js', post({updates}));
        }
        const verified = await request('cart.js');
        if (attemptLines(verified, attempt).length) throw new Error('cleanup_incomplete');
      };
      root.querySelectorAll('[data-jarvis-add-room-reset]').forEach(button => {
        const card = button.closest('[data-jarvis-component-handles]');
        const status = card.querySelector('[data-bundle-status]');
        const cartLink = card.querySelector('[data-bundle-cart-link]');
        if (button.dataset.complete !== 'true') return;
        button.disabled = false;
        button.addEventListener('click', async () => {
          if (button.disabled || root.dataset.adding === 'true') return;
          root.dataset.adding = 'true';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = message('Adding');
          status.textContent = '';
          let submitted = false;
          let postConfirmed = false;
          let attempt;
          try {
            const rows = [...card.querySelectorAll('[data-bundle-component]')];
            const handles = card.dataset.jarvisComponentHandles.split(',');
            const expectedCount = Number(card.dataset.componentCount);
            if (rows.length !== expectedCount || handles.length !== expectedCount || !expectedCount) throw new Error('changed');
            const items = rows.map((row, index) => {
              const id = Number(row.dataset.variantId);
              const price = Number(row.dataset.price);
              const quantity = Number(row.dataset.quantity);
              if (row.dataset.available !== 'true' || row.dataset.productHandle !== handles[index] || !Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(price) || price < 0 || quantity !== 1) throw new Error('changed');
              return {id, price, quantity, title: row.dataset.variantTitle, handle: row.dataset.productHandle};
            });
            if (new Set(items.map(item => item.id)).size !== expectedCount) throw new Error('changed');
            const total = Number(card.querySelector('[data-bundle-total]')?.dataset.bundleTotal);
            if (items.reduce((sum, item) => sum + item.price, 0) !== total) throw new Error('changed');
            const currentCart = await request('cart.js');
            if (currentCart.currency !== root.dataset.currency) throw new Error('changed');
            await Promise.all(items.map(async item => {
              const product = await request(`products/${encodeURIComponent(item.handle)}.js`);
              const variant = product.variants?.find(candidate => candidate.id === item.id);
              if (!variant || variant.available !== true || variant.price !== item.price || variant.title !== item.title || product.requires_selling_plan === true) throw new Error('changed');
              const rule = variant.quantity_rule;
              if (rule && (rule.min > 1 || rule.increment > 1 || (rule.max != null && rule.max < 1))) throw new Error('changed');
            }));
            attempt = crypto.randomUUID();
            const payload = items.map(item => ({id: item.id, quantity: item.quantity, properties: {_cozy_room_reset: attempt}}));
            submitted = true;
            await request('cart/add.js', post({items: payload}));
            postConfirmed = true;
            const resultCart = await request('cart.js');
            const added = attemptLines(resultCart, attempt);
            if (resultCart.currency !== root.dataset.currency || added.length !== expectedCount || !items.every(item => added.some(line => line.variant_id === item.id && line.quantity === item.quantity && line.original_price === item.price))) throw new Error('incomplete_set');
            button.textContent = message('Added');
            status.textContent = message('Success');
            cartLink.hidden = false;
          } catch (error) {
            if (submitted) {
              let cleaned = false;
              try { await cleanupAttempt(attempt); cleaned = true; } catch (_) {}
              status.textContent = message(cleaned && postConfirmed ? 'Cleaned' : 'CartUncertain');
              cartLink.hidden = false;
              button.textContent = message('Add');
            } else {
              status.textContent = message(error.message === 'changed' ? 'Changed' : 'CheckFailed');
              button.textContent = message('Add');
              button.disabled = error.message === 'changed';
            }
          } finally {
            button.removeAttribute('aria-busy');
            delete root.dataset.adding;
          }
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
